import React from 'react';
import './page-backdrop.css';

const PageBackdrop: React.FC = () => {
	return <div className='page-backdrop'></div>;
};

export default PageBackdrop;
